import { DateUtils } from '@vectord/utils';

function toDDMMMYYYYHHMM(date: Date): string {
  return `${DateUtils.toDDMMMYYYY(date)}, ${DateUtils.toHHmm(date)}`;
}

export default toDDMMMYYYYHHMM;
